export default __webpack_public_path__ + "images/models/1ec287aab299c98238cfb2f0745b20f3.glb";